<div>
    <input type="hidden"
           [id]="fieldId"
           [name]="ctrlName"
           [attr.value]="ctrlValue" />
</div>
